export default {
	// Disable the feedback button in the bottom right
	NO_FEEDBACK: "noFeedback",

	//
	SETTINGS: "settings",

	// Auto populates the feedback about input with the current user
	USER_PAGE: "userpage",

	// Will force the page to do a hard page load
	USES_TEMPLATE: "usesTemplate",

	// Triggers template full reload while keeping React visible
	USES_TEMPLATE_AND_REACT: "usesTemplateAndReact",

	// Hides the admin nav
	HIDE_ADMIN_NAV: "hideAdminNav",
};
